var icons_map_js = require('./lib/icons-map.js');

'use strict';

module.exports = {
    iconsMap: icons_map_js.default
};
